// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/iconfont2/iconfont.css
// module id = AtDH
// module chunks = 111